import { render, staticRenderFns } from "./orderHoldDialog.vue?vue&type=template&id=748b1229&"
import script from "./orderHoldDialog.vue?vue&type=script&lang=js&"
export * from "./orderHoldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports